module.exports = __webpack_public_path__ + "static/media/srvy-blue.297e71a1.png";